"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getIndexPrefix = function getIndexPrefix(_ref) {
  var projectId = _ref.projectId,
      index = _ref.index;

  if (!projectId || !index) {
    throw new Error('missing arguments');
  }

  return "arranger-projects-".concat(projectId, "-").concat(index);
};

var _default = getIndexPrefix;
exports["default"] = _default;